import { handleCopyClipBoard } from '@/shared/utils/clipboard'
import { getModifiedDate, yyyyMMdd_EEE } from '@/shared/utils/date'
import { getMapParkinglotURL, makeUtmTagWhenAppDownClick } from '@/shared/utils/dynamicLink'
import { getGeoCodeNeighborsWithSelf } from '@/shared/utils/geocode'
import { getCurrentLatLng } from '@/shared/utils/location'
import { handleRadioChange } from '@/shared/utils/radiohandler'
import { allCrawlersPattern } from '@/shared/utils/regexPatterns'

const Utils = {
  yyyyMMdd_EEE,
  getModifiedDate,
  getCurrentLatLng,
  makeUtmTagWhenAppDownClick,
  getMapParkinglotURL,
  handleCopyClipBoard,
  allCrawlersPattern,
  getGeoCodeNeighborsWithSelf,
  handleRadioChange
}

export default Utils
